import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import listingImg from "../../images/listingImg.jpg";
import listingImg2 from "../../images/listingImg2.jpg";
import TodoCard from "./todoCard";
import { useEffect, useState } from "react";
import moment from "moment";

const TodoList = ({ activities, selectedDate, getHomeData }) => {
  const [categories, setCategories] = useState([
    {
      name: "Planlagt",
      activities: [],
    },
    {
      name: "Afsluttet",
      activities: [],
    },
  ]);
  const [showDate, setShowDate] = useState("");
  useEffect(() => {
    let pendingTask = [];
    let completedTask = [];
    if (activities && activities.length > 0) {
      activities.map((val) => {
        let data = {
          ...val,
          task_start_time: moment(
            val.task_start_time,
            "HH:mm:ss.SSSSSS"
          ).format("HH:mm"),
          task_end_time: moment(val.task_end_time, "HH:mm:ss.SSSSSS").format(
            "HH:mm"
          ),
        };
        if (+val.task_status === 0) {
          pendingTask.push(data);
        } else {
          completedTask.push(data);
        }
      });
    }
    setCategories([
      {
        name: "Planlagt",
        activities: pendingTask,
      },
      {
        name: "Afsluttet",
        activities: completedTask,
      },
    ]);

    const formattedDate = moment(selectedDate).format("dddd, MMMM Do");
    setShowDate(formattedDate);
  }, [activities]);
  console.log("ACtivities", categories);
  return (
    <div className="w-full max-w-4xl mx-auto mt-4">
      <h2 className="text-lg font-semibold bg-theme text-center text-white py-2 px-4 rounded-2xl mb-4">
      To-do liste
      </h2>
      <TabGroup>
        <TabList className="flex justify-center">
          {categories && categories.length > 0 ? (
            categories.map(({ name, id }, index) => (
              <Tab
                key={id}
                className={`py-3 px-4 text-sm font-normal text-white focus:outline-none bg-[#8A8A8A] data-[selected]:bg-[#03A067] w-full 
              ${index === 0 ? "rounded-s-2xl" : ""} 
              ${index === categories.length - 1 ? "rounded-r-2xl" : ""}`}
              >
                {name}
              </Tab>
            ))
          ) : (
            <></>
          )}
        </TabList>
        <TabPanels className="mt-4">
          {categories && categories.length > 0 ? (
            categories.map(({ name, activities }) => (
              <TabPanel key={name}>
                <div className="grid grid-cols-1 gap-4">
                  {activities && activities.length > 0 ? (
                    activities.map((task, index) => (
                      <TodoCard
                        key={index}
                        {...task}
                        getHomeData={getHomeData}
                      />
                    ))
                  ) : (
                    <h1>Ingen opgaveliste til rådighed</h1>
                  )}
                </div>
              </TabPanel>
            ))
          ) : (
            <></>
          )}
        </TabPanels>
      </TabGroup>
    </div>
  );
};

export default TodoList;
